<template>
  <div class="w-full">
    <div class="sticky top-0 z-10 flex items-center justify-between h-16 px-4 bg-white border-b lg:px-6">
      <h1 class="text-lg font-bold">
        Edit Address
      </h1>
    </div>
    <div class="px-4 py-3 border-b lg:px-6 bg-gray-50">
      <router-link :to="{ name: 'CustomerAddressList' }" class="text-accent">
        &larr; Back to Address Book
      </router-link>
    </div>
    <Loading v-if="loading" class="p-8" />
    <div v-else class="max-w-lg p-4 lg:p-6">
      <customer-address-form mode="edit" :address="address" @success="success" />
    </div>
  </div>
</template>

<script>
import CustomerAddressForm from './CustomerAddressForm'

export default {
  name: 'CustomerAddressCreate',

  components: {
    CustomerAddressForm
  },

  created () {
    this.getAddress()
  },

  data () {
    return {
      loading: true,
      address: {}
    }
  },

  methods: {
    async getAddress () {
      try {
        const { data } = await this.$api.get(`portal/${this.$store.state.portal.subdomain}/customer/addresses/${this.$route.params.id}`)
        this.address = data.address
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    async success () {
      this.$toasted.show('Address Created')
      this.$router.push({ name: 'CustomerAddressList' })
    }
  }
}
</script>
